module.exports = __webpack_public_path__ + "static/img/blue-open.af732f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/blue-open.svg
// module id = YGia
// module chunks = 66